import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import BuildIcon from '@mui/icons-material/Build';
import PsychologyIcon from '@mui/icons-material/Psychology';

const difficulties = [
  { value: 'easy', label: '简单', icon: <SchoolIcon />, color: '#4caf50' },
  { value: 'medium', label: '中等', icon: <BuildIcon />, color: '#ff9800' },
  { value: 'hard', label: '困难', icon: <PsychologyIcon />, color: '#f44336' }
];

function DifficultySelector({ difficulty, onDifficultyChange }) {
  const handleChange = (event, newDifficulty) => {
    if (newDifficulty !== null) {
      onDifficultyChange(newDifficulty);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        选择难度级别
      </Typography>
      <ToggleButtonGroup
        value={difficulty}
        exclusive
        onChange={handleChange}
        aria-label="难度选择"
        sx={{ mb: 2 }}
      >
        {difficulties.map((diff) => (
          <ToggleButton 
            key={diff.value} 
            value={diff.value}
            sx={{ 
              px: 3, 
              py: 1,
              color: difficulty === diff.value ? 'white' : diff.color,
              bgcolor: difficulty === diff.value ? diff.color : 'transparent',
              '&.Mui-selected': {
                bgcolor: diff.color,
                '&:hover': {
                  bgcolor: diff.color,
                }
              },
              '&:hover': {
                bgcolor: `${diff.color}22`
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {diff.icon}
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                {diff.label}
              </Typography>
            </Box>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

export default DifficultySelector; 